import { IonRouterOutlet } from '@ionic/react';
import { useMemo } from 'react';
import { Route } from 'react-router-dom';

import { usePlatform } from '@/hooks/usePlatform';
import { lazyImport } from '@/utils/lazyImport';

const { TabBar } = lazyImport(() => import('../components/TabBar'), 'TabBar');

const { Guide } = lazyImport(() => import('@/features/guide'), 'Guide');
const { Map } = lazyImport(() => import('@/features/map'), 'Map');
const { MyVisit } = lazyImport(() => import('@/features/my-visit'), 'MyVisit');
const { OtherPasses } = lazyImport(() => import('@/features/other-passes'), 'OtherPasses');
const { PassDetail } = lazyImport(() => import('@/features/pass-detail'), 'PassDetail');
const { FAQ } = lazyImport(() => import('@/features/faq'), 'FAQ');
const { Catalog } = lazyImport(() => import('@/features/catalog'), 'Catalog');

export const TabBarRoutes = () => {
  const isDev = import.meta.env.DEV;
  const { isWeb } = usePlatform();
  const showTabBar = useMemo(() => isDev && isWeb, [isWeb, isDev]);

  const renderRoutes = () => (
    <IonRouterOutlet>
      <Route exact path="/guide" render={() => <Guide />} />
      <Route exact path="/my-visit" render={() => <MyVisit />} />
      <Route exact path="/map" render={() => <Map />} />
      <Route exact path="/buy" render={() => <Catalog />} />

      <Route exact path="/my-visit/other-passes" render={() => <OtherPasses />} />
      <Route exact path="/my-visit/passes/:id" render={() => <PassDetail />} />
      <Route exact path="/my-visit/faq" render={() => <FAQ />} />
    </IonRouterOutlet>
  );

  return showTabBar ? <TabBar>{renderRoutes()}</TabBar> : renderRoutes();
};
